<template>
    <div class="row justify-content-center">
        <div class="col-12 col-md-10">
            <div class="row main-news">
                <div class="col-md-6" v-if="index % 2 === 1"></div>
                <a class="news-image"
                   :class="{'news-image-right': index % 2 === 0, 'news-image-left': index % 2 === 1}"
                   :href="item.route">
                    <img :src="item.imageUrl" width="100%"
                         :alt="item.imageAlt">
                </a>
                <div class="col-12 col-md-6 text-content">
                    <a style="text-decoration: none" :href="item.route">
                        <h2 class="section-title text-left">{{ item.headline }}</h2>
                        <p>{{ item.teaser }}</p>
                    </a>
                    <a :href="item.route" class="btn btn-more">
                        <span>Weiterlesen</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
name: "NewsItem",
    props: ['item', 'index']
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/js/components/NewsItem.vue